<div class="dialog-surface">
  <div class="dialog-header">
    <div class="dialog-title">{{ variables?.notifDetailTitle || 'Notification detail' }}</div>
    <button type="button" class="dialog-close" (click)="close()"
      [attr.aria-label]="variables?.notifDetailClose || 'Cerrar'">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <div class="data-row">
      <div class="label">{{ variables?.notificationType || 'Tipo' }}</div>
      <div class="value">
        {{ getTypeMeta(notification.eventType)?.icon }}
        {{ getTranslatedTypeLabel(getTypeMeta(notification.eventType)?.code || '', getTypeMeta(notification.eventType)?.label || notification.eventType) }}
      </div>
    </div>

    <div class="data-row">
      <div class="label">{{ variables?.priority || 'Prioridad' }}</div>
      <div class="value">
        <span class="priority-chip" [ngClass]="'priority-' + notification.priority">
          {{ getPriorityLabel(notification.priority) }}
        </span>
      </div>
    </div>

    <div class="data-row">
      <div class="label">{{ variables?.notificationSubject || 'Asunto' }}</div>
      <div class="value">{{ notification.subject }}</div>
    </div>

    <div class="data-row body-row">
      <div class="label">{{ variables?.notifDetailBody || 'Cuerpo' }}</div>
      <div class="value body-content" [innerHTML]="notification.body"></div>
    </div>

    <div class="data-row">
      <div class="label">{{ variables?.notificationDate || 'Fecha' }}</div>
      <div class="value">{{ notification.date}}</div>
    </div>

    <div class="data-row">
      <div class="label">{{ variables?.notificationReadDate || 'Fecha de lectura date' }}</div>
      <div class="value">{{ formatReadDate(notification.readDate) }}</div>
    </div>
  </div>

  <div class="dialog-actions">
    <button type="button" class="dialog-bottom-close" (click)="close()">
      {{ variables?.notifDetailClose || 'Close' }}
    </button>
  </div>
</div>
